export const resolveImageUrl = (url: string | undefined | null) => {
    if (!url) return '';
    if (url.startsWith('http')) return url; // Already absolute

    // Clean backslashes if any (from Windows paths)
    const cleanUrl = url.replace(/\\/g, '/');

    // Get backend URL from env
    const backendBase = import.meta.env.VITE_BACKEND_BASE_URL || import.meta.env.VITE_API_BASE_URL || '';

    // Remove trailing slash from base
    const cleanBase = backendBase.replace(/\/$/, '');

    // Ensure leading slash on path
    const finalPath = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;

    return `${cleanBase}${finalPath}`;
};
